import React from 'react';

import PropTypes from 'prop-types';

import showIcon from 'images/icons/invite/view.svg';

import { useNavigate } from 'react-router-dom';

// import actions from 'components/Admin/Avatars/Actions/Actions';

export default function Actions({ row }) {
  const navigate = useNavigate();

  const onShowClick = () => {
    navigate(`/admin/ai_sessions/${row.session_id}`);
  };

  return (
    <div>
      <a onClick={onShowClick} className="mr10">
        <img src={showIcon} />
      </a>

    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
